<template>
  <el-dialog :title="form.id ? '编辑反馈类型' : '新增反馈类型'" :visible.sync="formVisible" width="620px" :close-on-click-modal="false">
    <el-form ref="dataForm" :model="form" :rules="formRules" label-width="110px" size="small">
      <el-form-item label="类型名称" prop="typeName">
        <el-input v-model="form.typeName" placeholder="请输入类型名称" maxlength="64" />
      </el-form-item>
      <el-form-item label="类型说明" prop="typeDesc">
        <el-input v-model="form.typeDesc" placeholder="请输入类型说明" maxlength="255" />
      </el-form-item>
      <el-form-item label="适用端" prop="applyEnd">
        <el-select v-model="form.applyEnd" placeholder="请选择适用端">
          <el-option v-for="item in applyEndOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="默认处理部门" prop="defaultDeptId">
        <el-select v-model="form.defaultDeptId" filterable clearable placeholder="请选择处理部门（选填）" @change="handleDeptChange">
          <el-option v-for="item in deptOptions" :key="item.id" :label="item.deptName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理时限" prop="handleHours">
        <el-select v-model="form.handleHours" placeholder="请选择处理时限">
          <el-option v-for="item in handleHoursOptions" :key="item" :label="item + '小时'" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用" prop="enabled">
        <el-radio-group v-model="form.enabled">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="orderNo">
        <el-input-number v-model="form.orderNo" controls-position="right" :min="0" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="doCreate()">确定</el-button>
      <el-button size="small" @click="formVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import customerComplaintTypeApi from '@/api/complaint/customerComplaintType'
import sysDeptApi from '@/api/sys/sysDept'

function initFormBean() {
  return {
    id: null,
    typeName: null,
    typeDesc: null,
    applyEnd: 'APP端',
    defaultDeptId: null,
    defaultDeptName: null,
    handleHours: null,
    enabled: 1,
    orderNo: 1
  }
}

export default {
  name: 'ComplaintTypeAdd',
  data() {
    return {
      formVisible: false,
      isRepSub: false,
      form: initFormBean(),
      applyEndOptions: ['APP端', '管理端', '全部端'],
      handleHoursOptions: [12, 24, 48, 72],
      deptOptions: [],
      formRules: {
        typeName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
        applyEnd: [{ required: true, message: '请选择适用端', trigger: 'change' }],
        handleHours: [{ required: true, message: '请选择处理时限', trigger: 'change' }],
        orderNo: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 🔴 部门下拉读的是 **sys_dept**，不是 sys_department。
    //
    // 原来读 `@/api/config/sysDepartment`（表 `sys_department`）——
    // **那张表在生产上是空的**（2026-09-06 只读查证：sys_department 0 行、
    // sys_dept 18 行，真实部门"营销开发/管理部、董事办、教育部、财务部…"全在 sys_dept）。
    // 它不是本期建的，是一张从来没启用过的旧表。
    //
    // 后果是阻断级：本表单 defaultDeptId 是**必填**，且新增/编辑共用同一套校验，
    // 下拉空 → 新增建不出反馈类型；发版 SQL 初始化的 4 条类型没带部门，
    // 编辑它们时同样被必填拦住 —— **连处理时限都改不了**。
    //
    // ⚠️ 不要反过来"往 sys_department 补数据"：那等于把废弃表重新启用，
    // 以后部门要在两张表里各维护一份，必然分叉。
    getDeptOptions() {
      if (this.deptOptions.length) return
      return sysDeptApi.fetchList({ pageNo: 1, pageSize: 1000 }).then(({ data }) => {
        const list = (data && data.list) || []
        // 只留启用中的部门：生产上有一条重复的「品牌部」是 dept_status=0，
        // 不过滤会在下拉里出现两个同名项，客户不知道该选哪个。
        // 在前端过滤而不是给 /options 加条件：那个接口是部门管理页共用的，
        // 那边需要看到停用的部门。
        this.deptOptions = list.filter(item => item.deptStatus === 1)
      })
    },
    handleDeptChange(val) {
      const dept = this.deptOptions.find(item => item.id === val)
      // sys_dept 的名称列是 deptName（sys_department 那张废表才叫 name）
      this.form.defaultDeptName = dept ? dept.deptName : null
    },
    handleCreate() {
      this.form = initFormBean()
      this.getDeptOptions()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.form = { ...initFormBean(), ...row }
      this.getDeptOptions()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs['dataForm'].validate(valid => {
        if (!valid) return
        if (this.isRepSub) return
        this.isRepSub = true
        customerComplaintTypeApi.save({ ...this.form })
          .then(() => {
            this.$message.success('操作成功')
            this.formVisible = false
            this.$emit('created')
          })
          .finally(() => {
            this.isRepSub = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
